import dynamic from 'next/dynamic'
import { FunctionComponent } from 'react'
import styled from 'styled-components'

import Spacer from 'components/Spacer'

import * as T from 'types'

import ContactSeller from './ContactSeller'
import ListingDetails from './ListingDetails'
import OpenHouse from './OpenHouses'

const SocialBar = dynamic(() => import('./SocialBar'), {
  ssr: false,
})

const SidebarContainer = styled.aside`
  box-sizing: border-box;
  margin: 0px;
  flex: 1 0 auto;
  max-width: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 0;
    max-width: ${props => props.theme.metrics.publicListingSidebarTabletWidth}px;
    min-width: ${props => props.theme.metrics.publicListingSidebarTabletWidth}px;
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    max-width: ${props => props.theme.metrics.publicListingSidebarWidth}px;
    min-width: ${props => props.theme.metrics.publicListingSidebarWidth}px;
  }
`

interface IProps {
  listing: T.IListing
}

const Sidebar: FunctionComponent<IProps> = ({ listing }) => (
  <SidebarContainer>
    <ListingDetails listing={listing} />
    <Spacer size={10} />
    <SocialBar listing={listing} />
    <Spacer size={10} />
    <ContactSeller listing={listing} />
    <OpenHouse listing={listing} />
    <Spacer size={10} />
  </SidebarContainer>
)

export default Sidebar
